// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cart-item-img[data-v-69fb6fdd]{position:relative}.treatment-text[data-v-69fb6fdd]{font-size:14px;font-weight:700;line-height:14px}.treatment-text__name[data-v-69fb6fdd]:hover{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.price__from[data-v-69fb6fdd]{font-size:13px;font-weight:700;letter-spacing:-.5px;line-height:15px}.price__number[data-v-69fb6fdd]{font-size:18px;font-weight:700;letter-spacing:0;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
